import React, { useCallback, useEffect, useState } from "react";
import { isAndroid, isMobile, isSafari, isTablet } from "react-device-detect";
import IconButton from "@common/LifeAtButton/Variants/IconButton";
import { AppearanceContextType, useAppearanceContext } from "@contexts/AppearanceContext";
import "./FullScreenButton.scss";
import FullScreenCloseIcon from "/resources/icons/FullScreenCloseIcon.svg";
import FullScreenIcon from "/resources/icons/FullScreenIcon.svg";

export default function FullScreenButton() {
    const { lightMode }: AppearanceContextType = useAppearanceContext();

    const [isFullScreen, setIsFullScreen] = useState<boolean>(false);

    const exitHandler = useCallback((event) => {
        if (
            !document.fullscreenElement &&
            !document.webkitIsFullScreen &&
            !document.mozFullScreen &&
            !document.msFullscreenElement
        ) {
            setIsFullScreen(false);
        }
    }, []);

    useEffect(() => {
        document.addEventListener("fullscreenchange", exitHandler);
        document.addEventListener("webkitfullscreenchange", exitHandler);
        document.addEventListener("mozfullscreenchange", exitHandler);
        document.addEventListener("MSFullscreenChange", exitHandler);

        return () => {
            document.removeEventListener("fullscreenchange", exitHandler);
            document.removeEventListener("webkitfullscreenchange", exitHandler);
            document.removeEventListener("mozfullscreenchange", exitHandler);
            document.removeEventListener("MSFullscreenChange", exitHandler);
        };
    }, []);

    // Could copy logic from fscreen repo: https://github.com/rafgraph/fscreen
    // Currently does not support Safari.
    // Source for below: https://stackoverflow.com/questions/9620223/make-div-fullscreen-onclick-of-a-button
    const toggleFullScreen = () => {
        if (isFullScreen) {
            if (document.exitFullscreen) {
                document.exitFullscreen().then((r) => setIsFullScreen(false));
            }
        } else {
            const elem = document.getElementById("root");
            if (elem.requestFullscreen) {
                elem.requestFullscreen().then((r) => setIsFullScreen(true));
            }
        }
    };
    //variable buttonIcon
    const buttonIcon = isFullScreen ? (
        <FullScreenCloseIcon className={`fullscreen-icon ${lightMode ? "light" : "dark"}`} />
    ) : (
        <FullScreenIcon className={`fullscreen-icon ${lightMode ? "light" : "dark"}`} />
    );

    return (!(isMobile || isTablet) && !isSafari) || isAndroid ? (
        <IconButton
            className={`full-screen-button`}
            variant={"normal"}
            size={"small"}
            onClick={() => toggleFullScreen()}
        >
            {buttonIcon}
        </IconButton>
    ) : null;
}
